import './KeyValueRow.css';
import { t } from '../copy/strings';
import { fmtInt } from '../format/numbers';
import { AnimatedNumber } from './AnimatedNumber';

export interface KeyValueRowProps {
  /** Chave (`<dt>`), string pronta do dono (§7.7, §8). */
  label: string;
  /** Valor (`<dd>`): número anima com `AnimatedNumber`; texto entra como está; `null` = "–". */
  value: string | number | null;
  /** Formatador do valor numérico (§13.4); padrão `fmtInt`. */
  format?: (v: number) => string;
  /** Cópia .sr-only quando difere do visível (abreviações por extenso, sinais; §15.4.3). */
  srFormat?: (v: number) => string;
  /** Classes extras do dono. */
  class?: string;
}

/**
 * Linha chave-valor (§3.9 `KeyValueRow`): um par `<dt>`/`<dd>` agrupado num `<div>` (filho válido de `<dl>`). Vai
 * sempre dentro de um `<dl>`; o contêiner da ficha é o `<dl class="kv-list">` do dono (AC-3.9-03), estilizado em
 * KeyValueRow.css. Não há componente de lista: §2.3.4 só admite os nomes canônicos (FE §13.4 regra 8).
 */
export function KeyValueRow({ label, value, format = fmtInt, srFormat, class: extra }: KeyValueRowProps) {
  const empty = value === null;
  return (
    <div
      class={extra ? `key-value-row ${extra}` : 'key-value-row'}
      data-testid="key-value-row"
      data-state={empty ? 'empty' : undefined}
    >
      <dt class="key-value-row__key">{label}</dt>
      <dd class="key-value-row__value">
        {typeof value === 'number' ? (
          <AnimatedNumber value={value} format={format} srFormat={srFormat} />
        ) : empty ? (
          t('common.dash')
        ) : (
          value
        )}
      </dd>
    </div>
  );
}
